import { render, staticRenderFns } from "./ContactTypeModal.vue?vue&type=template&id=19950535&"
import script from "./ContactTypeModal.vue?vue&type=script&lang=js&"
export * from "./ContactTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./ContactTypeModal.vue?vue&type=style&index=0&id=19950535&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports